import { render, staticRenderFns } from "./IconChooserDialog.vue?vue&type=template&id=31822ae8&"
import script from "./IconChooserDialog.vue?vue&type=script&lang=ts&"
export * from "./IconChooserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./IconChooserDialog.vue?vue&type=style&index=0&id=31822ae8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports